// JAVASCRIPT LAYER [APP.JS]  =========================================================================================

// ====== INDEX  ======================================================================================================
// ==
// == A. BURGER MENU
// == B. HOMEPAGE CAROUSEL
// ==
// ====== INDEX  ======================================================================================================

// A. SHOW/HIDE +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++

// A.1. BURGER MENU ---------------------------------------------------------------------------------------------------

// $(".reveal").click(function (e) {
//   var target = $(this).attr("href");
//
//   if ($(target).hasClass("hidden")) {
//     $(target).removeClass("hidden");
//     $(".reveal").addClass("close");
//   } else {
//     $(target).addClass("hidden");
//     $(".reveal").removeClass("close");
//   }
//   e.preventDefault();
// });

$(".a-nav-icon").click(function (e) {
  $(this).toggleClass("open");
  $(".m-menu").toggleClass("slide-out", "slide-in");
  $(".o-header").toggleClass("open");
});

$("div.m-menu-items ul li").each(function () {
  if ($(this).find("ul.m-sub-menu").length !== 0) {
    //$(this).addClass('has-dropdown');
    $(this).prepend(
      '<button class="d-inline-block d-lg-none toggle-submenu a-mobile-caret">EXPAND</button>'
    );
  }
});

$(".a-mobile-caret").click(function (e) {
  $(this).toggleClass("active");
});

// A.1. END -----------------------------------------------------------------------------------------------------------

// A.2. GENERAL SHOW --------------------------------------------------------------------------------------------------

var isIE11 = !!navigator.userAgent.match(/Trident.*rv\:11\./);
if (isIE11) {
  jQuery("body").addClass("ie-11");
}

// $(".showhide").click(function (e) {
//   var target = $(this).attr("href");

//   if ($(target).hasClass("hidden")) {
//     $(target).removeClass("hidden");
//     $(".showhide").addClass("close");
//   } else {
//     $(target).addClass("hidden");
//     $(".showhide").removeClass("close");
//   }

//   e.preventDefault();
// });

// A.2. END -----------------------------------------------------------------------------------------------------------

// A.2. END -----------------------------------------------------------------------------------------------------------

// A.2.1. TOGGLE DIV ----------------------------

// var currentContent = "";
// $(".toggle-div").on("click", function () {
//   currentContent = $(this).attr("name");
//   if ($("#" + currentContent).hasClass("on")) {
//     $("#" + currentContent).removeClass("on");
//     $("body").removeClass("modal-open");
//   } else {
//     hideAllContent();
//     showCurrentContent(currentContent);
//   }
// });

// function hideAllContent() {
//   $(".toggle-content").removeClass("on");
//   $("body").removeClass("modal-open");
// }

// function showCurrentContent(currentContentDiv) {
//   $("#" + currentContentDiv).addClass("on");
//   $("body").addClass("modal-open");
// }

// A.2.1. END -----------------------------------------

// A.2.2. MODAL POPUPS --------------------------------

// var modalContent = "";
// $(".modal-open").on("click", function () {
//   modalContent = $(this).attr("name");
//   if ($("#" + modalContent).hasClass("on")) {
//     $("#" + modalContent).removeClass("on");
//     $("body").removeClass("modal-open");
//   } else {
//     hideAllContent();
//     showmodalContent(modalContent);
//   }
// });

// function hideAllContent() {
//   $(".o-modal-full").removeClass("on");
//   $("body").removeClass("modal-open");
// }

// function showmodalContent(modalContentDiv) {
//   $("#" + modalContentDiv).addClass("on");
//   $("body").addClass("modal-open");
// }

// var featureVid = document.getElementById("modal--video-player");

// function pauseFeaturedVid() {
//   featureVid.pause();
// }

// $(".a-modal-close").on("click", function () {
//   $("body").removeClass("modal-open");
//   $(".o-modal-full").removeClass("on");
//   pauseFeaturedVid();
// });

// A.2.2. END -----------------------------------------

// A.2.3. MOBILE SHOWHIDE -----------------------------

//(function ($) {
// if ($("html").hasClass("mobile")) {
//   $(".a-config").on("click", function () {
//     //e.preventDefault();
//     if ($(".a-config").hasClass("active")) {
//       $(".a-config").removeClass("active");
//       $("body").removeClass("fixed");
//     } else {
//       $(".a-config").addClass("active");
//       $("body").addClass("fixed");
//     }
//   });
// }

// A.2.4. GRID APARTMENTS -----------------------------
// if($('html').hasClass('mobile')){
//   $('.o-grid-apartments .m-block .m-link').on('click', function(e){
//     if ($(this).hasClass('clicked')) {
//       return true;
//     } else {
//       $(this).addClass('clicked');
//       e.preventDefault();
//     }
//   });
// }

// A.2.4. END -----------------------------------------
//})(jQuery);

// A.2.3. END -----------------------------------------

// A.2. END -----------------------------------------------------------------------------------------------------------

// A.3. SCROLL TO LINK ------------------------------------------------------------------------------------------------

// $(".textLink, .bob-backUp").click(function (event) {
//   event.preventDefault();
//
//   //calculate destination place
//   var dest = 0;
//   if ($(this.hash).offset().top > $(document).height() - $(window).height()) {
//     dest = $(document).height() - $(window).height();
//   } else {
//     dest = $(this.hash).offset().top;
//   }
//
//   //go to destination
//   $("html,body").animate({ scrollTop: dest }, 1000, "swing");
//
//   //add class to burger
//   $("#mobi-nav").addClass("hide-nav");
// });

// A.3. END -----------------------------------------------------------------------------------------------------------

// $(".cta-hook a").click(function (event) {
//   event.preventDefault();
//   //calculate destination place
//   var dest = 0;
//   if ($(this.hash).offset().top > $(document).height() - $(window).height()) {
//     dest = $(document).height() - $(window).height();
//   } else {
//     dest = $(this.hash).offset().top;
//   }

//   //go to destination
//   $("html,body").animate(
//     { scrollTop: dest - $(".o-header").height() },
//     1000,
//     "swing"
//   );
// });

// if ($(".webform-confirmation__message").length) {
//   dest = $(".register-interest-form").offset().top;
//   $("html,body").animate(
//     { scrollTop: dest - $(".o-header").height() },
//     1000,
//     "swing"
//   );
// }

// A.4. SHOW HIDE LOGO ------------------------------------------------------------------------------------------------

var t = $("html").offset().top;

$(document).scroll(function () {
  if (document.documentElement.clientWidth > 640) {
    // Hide the logo, and show as you scroll
    if ($(this).scrollTop() > t) {
      $(".logo").css({ display: "block" });
    } else {
      $(".logo").css({ display: "none" });
    }
  } else {
  }
});

// A.4. END -----------------------------------------------------------------------------------------------------------

// A.5. SCREEN SIZE CHECK ---------------------------------------------------------------------------------------------

var screen = $(window).width();
if ($("body").hasClass("adminimal-admin-toolbar")) {
  // console.log('I am a device, and my width is: ' + screen);
}

// A.5. END -----------------------------------------------------------------------------------------------------------

// A.6. RESOURCE PATHS ------------------------------------------------------------------------------------------------

var icons = "assets/includes/icons/";

// A.6. END -----------------------------------------------------------------------------------------------------------

// A.7. SELECTY -------------------------------------------------------------------------------------------------------
$(".selecty").each(function () {
  if (!$(this).hasClass("selecty-enabled")) {
    $(this).addClass("selecty-enabled");
    $(this).selecty();
  }
});
// A.7. END -----------------------------------------------------------------------------------------------------------

// A.8. CAROUSELS -----------------------------------------------------------------------------------------------------

if ($(window).width() <= 768) {
  jQuery(".building ").addClass("open-building");
}

if ($(window).width() <= 990) {
  jQuery(".main-menu-phone").parent().css("border-bottom", "0");
  jQuery(".main-menu-phone").appendTo(".m-menu-items-right");
  jQuery(".main-menu-phone").addClass("mobile-phone-menu");
}

// Unit hero mobile counter
// $(".unit-hero-carousel, .m-marketing-page-hero").on(
//   "initialized.owl.carousel changed.owl.carousel",
//   function (e) {
//     if (!e.namespace) {
//       return;
//     }
//     var carousel = e.relatedTarget;
//     $(".slider-counter").text(
//       carousel.relative(carousel.current()) + 1 + "/" + carousel.items().length
//     );
//   }
// );

// Building gallery mobile counter
// $(".m-building-listing-slide").on(
//   "initialized.owl.carousel changed.owl.carousel",
//   function (e) {
//     if (!e.namespace) {
//       return;
//     }
//     console.log("this happened");
//     var carousel = e.relatedTarget;
//     $(".slider-counter .a-current").text(
//       carousel.relative(carousel.current()) + 1
//     );
//     $(".slider-counter .a-total").text(carousel.items().length);
//   }
// );

// 2021 - Hero owl carousel progress bar END

// $(".owl-carousel").each(function () {
//   var options = false;
//   if ($(this).hasClass("unit-apartment-carousel")) {
//     options = {
//       dots: true,
//       autoplay: false,
//       nav: true,
//       loop: true,
//       items: 1,
//     };
//   }
//   if (options !== false) {
//     $(this).owlCarousel(options);
//   }
// });

// A.35. 2021 gallery lightbox nav left/right

// 2021 Image carousel twigger prev/next on scroll pad START
// var timestamp_mousewheel = 0;
// var Image2021Carousel = $(".m-2021-image-carousel");
// Image2021Carousel.on("mousewheel", ".owl-stage", function (a) {
//   var d = new Date();
//   if (d.getTime() - timestamp_mousewheel > 1000) {
//     //minimum time difference
//     timestamp_mousewheel = d.getTime();
//     if (a.deltaY < 0) Image2021Carousel.trigger("next.owl");
//     else Image2021Carousel.trigger("prev.owl");
//     a.preventDefault();
//   }
// });

// A.35. END -----------------------------------------------------------------------------------------------------------

function stopOwlPropagation(element) {
  jQuery(element).on("to.owl.carousel", function (e) {
    e.stopPropagation();
  });
  jQuery(element).on("next.owl.carousel", function (e) {
    e.stopPropagation();
  });
  jQuery(element).on("prev.owl.carousel", function (e) {
    e.stopPropagation();
  });
  jQuery(element).on("destroy.owl.carousel", function (e) {
    e.stopPropagation();
  });
}

stopOwlPropagation(".owl-carousel");

// A.27. STAR RATINGS -------------------------------------------------------------------------------------------------------
// jQuery(".m-star-rating").each(function () {
//   var val = jQuery(this).find(".a-value").text();
//   var filledBar = jQuery(this).find(".a-filled");

//   var calc = (val / 5) * 100 + "%";
//   filledBar.css("width", calc);
// });
// A.27. END -----------------------------------------------------------------------------------------------------------

// $(".o-2021-hero-image-gallery .m-thumbnail").click(function () {
//   var slide = $(this).attr("data-slide-to");
//   var owl = $(".m-2021-gallery-modal");
//   owl.trigger("to.owl.carousel", [slide, 0]);
// });

// $(".o-2021-instagram .m-img").click(function () {
//   var slide = $(this).attr("data-slide-to");
//   var owl = $(".m-2021-instagram-modal");
//   owl.trigger("to.owl.carousel", [slide, 0]);
// });

// $('.owl-carousel').on('touchstart', 'img', function(e) {
// 	$(this).closest('.owl-carousel').trigger('stop.owl.autoplay');
// });
// $('.owl-carousel').on('touchend', 'img', function(e) {
// 	$(this).closest('.owl-carousel').trigger('play.owl.autoplay');
// });
// $('.owl-carousel').on('click', '.owl-dots, .owl-nav', function(e) {
// 	$(this).closest('.owl-carousel').trigger('stop.owl.autoplay');
// 	$(this).closest('.owl-carousel').trigger('play.owl.autoplay');
// });

// A.8. END -----------------------------------------------------------------------------------------------------------

// A.10 SEARCH UNITS SHOW MORE ---------------------------------------------------------------------------------------

// $(".o-search-units .more a").on("click", function () {
//   $(".o-unit-search-result.hidden")
//     .slice(0, 8)
//     .css("opacity", "0")
//     .removeClass("hidden")
//     .animate({ opacity: "1" }, 500);
//   if (!$(".o-unit-search-result.hidden").length) {
//     $(this).closest("div").addClass("hidden");
//     $("<p>No more filtered results</p>").insertBefore($(this).closest("div"));
//   }
// });

// A.10 APARTMENT HERO GALLERY AND TOUR OPEN/CLOSE

// A.10.1 OPEN GALLERY/TOUR

// $(".js--a-btn-gallery").click(function () {
//   $(".o-hero-scaling").addClass("closed");
//   $(".o-apartment-gallery").addClass("open");
//   var owl = $(this).closest(".o-block").parent("div").find(".owl-carousel");
//   owl.trigger("to.owl.carousel", [0, 0]);
// });
// $(".js--a-virtual-tour").click(function () {
//   $(".o-hero-scaling").addClass("closed");
//   $(".m-virtual-tour").addClass("open");
// });

// A.10.1 END --------------------------------------------------------------------------------------------------------

// A.10.2 CLOSE GALLERY/TOUR

// $(".js--a-btn-gallery-close").click(function () {
//   $(".o-hero-scaling").removeClass("closed");
//   $(".o-apartment-gallery").removeClass("open");
//   var owl = $(this).closest(".m-container").prev(".owl-carousel");
//   owl.trigger("to.owl.carousel", [0, 0]);
// });

// $(".js--a-btn-tour-close").click(function () {
//   $(".o-hero-scaling").removeClass("closed");
//   $(".m-virtual-tour").removeClass("open");
// });

// A.10.2 END ---------------------------------------------------------------------------------------------------------

// A.10 END ----------------------------------------------------------------------------------------------------------

// A.11 BUILDING HERO GALLERY OPEN/CLOSE

// A.11.1 OPEN GALLERY

// $(".js--a-building-gallery").click(function () {
//   $(".o-hero-image-carousel").addClass("closed");
//   $(".o-apartment-gallery").addClass("open");
//   var owl = $(this).closest(".o-block").parent("div").find(".owl-carousel");
//   owl.trigger("to.owl.carousel", [0, 0]);
// });

// A.11.1 END ---------------------------------------------------------------------------------------------------------

// A.11.2 CLOSE GALLERY

// $(".js--a-building-gallery-close").click(function () {
//   $(".o-hero-image-carousel").removeClass("closed");
//   $(".o-apartment-gallery").removeClass("open");
//   var owl = $(this).closest(".m-container").prev(".owl-carousel");
//   owl.trigger("to.owl.carousel", [0, 0]);
// });

// A.11.2 END ---------------------------------------------------------------------------------------------------------

// A.11 END ----------------------------------------------------------------------------------------------------------

// A.12 TABS TRANSITION

// $(".o-tab .a-nav-link").click(function () {
//   if ($(this).attr("href") == "#available") {
//     $(".a-scroll-line").addClass("move");
//   } else {
//     $(".a-scroll-line").removeClass("move");
//   }
// });

// A.12 END ----------------------------------------------------------------------------------------------------------

// A.13 BODY LOADED --------------------------------------------------------------------------------------------------
$("body").addClass("loaded");
// A.13 END ----------------------------------------------------------------------------------------------------------

var queryVars = {};
var preFilter = false;
if (document.location.search.trim() != "") {
  jQuery.each(document.location.search.substr(1).split("&"), function (c, q) {
    var i = q.split("=");
    if (typeof i[1] !== "undefined") {
      queryVars[i[0].toString()] = i[1].toString();
    }
  });
  preFilter = typeof queryVars.qlbF !== "undefined" && !!queryVars.qlbF == true;
}

// localStorage.setItem("tipi-filters-limit", "6");
// A.14 RESET FILTERS ON SEARCH CTA ----------------------------------------------------------------------------------
// $("a.a-find-a-home").on("click", function (e) {
//   localStorage.setItem("tipi-filters-limit", "6");
//   var newFilters = {};
//   newFilters = JSON.stringify(newFilters);
//   localStorage.setItem("tipi-filters", newFilters);
//   var expireFilters = new Date(new Date().getTime() + 15 * 60000);
//   localStorage.setItem("tipi-filters-expire", expireFilters / 1);
// });
// A.14 END ----------------------------------------------------------------------------------------------------------
// console.log('split1');

// A.15 SET FILTERS ON SEARCH CTA BAR --------------------------------------------------------------------------------
// $('.looking-for-cta button[type="submit"]').on("click", function (e) {
//   var newFilters = {};
//   $(this)
//     .closest(".looking-for-cta")
//     .find("select")
//     .each(function () {
//       var value = $(this).val();
//       if (value.length) {
//         value = value.split("|");
//         newFilters[value[0]] = value[1] == "true" ? true : false;
//       }
//     });
//   newFilters = JSON.stringify(newFilters);
//   localStorage.setItem("tipi-filters", newFilters);
//   var expireFilters = new Date(new Date().getTime() + 15 * 60000);
//   localStorage.setItem("tipi-filters-expire", expireFilters / 1);
//   localStorage.setItem("tipi-filters-lfcta", true);
// });

// A.15 END ----------------------------------------------------------------------------------------------------------

// A.16 SCROLL TO ON CONTENT WITH BACKGROUND PARAGRAPHS --------------------------------------------------------------
// $(".o-content-with-background a.a-link.scroll-to").on("click", function (e) {
//   e.preventDefault();
//   var target = $($(this).attr("data-href"));
//   var dest = 0;
//   if (target.offset().top > $(document).height() - $(window).height()) {
//     dest = $(document).height() - $(window).height();
//   } else {
//     dest = target.offset().top;
//   }
//   // ensure we leave room for the main menu
//   dest -= $(".o-header.fixed-top").outerHeight();
//   //go to destination
//   $("html,body").animate({ scrollTop: dest }, 1000, "swing");
//   return false;
// });
// A.16 END ----------------------------------------------------------------------------------------------------------
// A.17 COOKIE MODULE ------------------------------------------------------------------------------------------------
// setTimeout(function() {
//   $('#ccc #ccc-module #ccc-content #cc-panel #ccc-end #ccc-dismiss-button').animate({opacity: 1}, 500);
// }, 5000);
// var sawCookies = TipiThemeGetCookie("cookieNotified");
// if (typeof sawCookies == "undefined") {
//   var oneYearFromNow = new Date();
//   oneYearFromNow.setFullYear(oneYearFromNow.getFullYear() + 1);
//   $(".o-cookie-notification a.a-cookie-close-link").fadeOut(0);
//   setTimeout(function () {
//     $(".o-cookie-notification").animate({ right: "0px" }, 750);
//   }, 250);
//   setTimeout(function () {
//     $(".o-cookie-notification a.a-cookie-close-link").fadeIn(750);
//   }, 6000);
//   $(".o-cookie-notification a").on("click", function (e) {
//     e.preventDefault();
//     e.stopPropagation();
//     document.cookie =
//       "cookieNotified=true; expires=" +
//       oneYearFromNow.toUTCString() +
//       "; path=/";
//     $(".o-cookie-notification").animate({ right: "-500px" }, 500);
//     setTimeout(function () {
//       $(".o-cookie-notification").remove();
//     }, 750);
//     return false;
//   });
// }

// Add class to main navigation on development pages
if (window.location.href.indexOf("development") > -1) {
  jQuery(".m-main-menu li:first-child a").addClass("is-active");
}
// A.17 END ----------------------------------------------------------------------------------------------------------

// A.17 SCROLL TO ON CONTENT WITH BACKGROUND PARAGRAPHS --------------------------------------------------------------
// $('.o-webform .webform-button--submit.button.form-submit').on('click', function(e) {
//   var foundErrors = false;
//   $(this).closest('form').find('.required').each(function() {
//     $(this).removeClass('error');
//     $(this).find('input').removeClass('error');
//     if (!$(this).val().length || ($(this).val() == 'Minimum' && $(this).hasClass('selecty')) || ($(this).val() == 'Maximum' && $(this).hasClass('selecty'))) {
//       foundErrors = true;
//       $(this).addClass('error');
//       $(this).find('input').addClass('error');
//     }
//   });
//   if (foundErrors) {
//     $(this).closest('.o-webform').append('<div data-drupal-messages><div role="alert"><ul><li>Please review the highlighted items below.</li></ul></div></div>');
//     $(this).closest('.o-webform').on('click', context, function() {
//       $(this).find('div[data-drupal-messages]').fadeOut(750, function() {
//         $(this).remove();
//       });
//     });
//   }
// });
// A.17 END ----------------------------------------------------------------------------------------------------------

// A.18 WHO IS HERE ARTICLES - LOAD MORE --------------------------------------------------------------

// $(".a-load-more").click(function (e) {
//   e.preventDefault();
//   $(".o-who-is-here-articles").addClass("load-more");
// });

// A.18 END ----------------------------------------------------------------------------------------------------------

// A.19 ARTICLE SELECTOR - LOAD MORE --------------------------------------------------------------

// $('.a-read-more').click(function(e) {
//   e.preventDefault();
//   $('.o-article-selector').addClass('load-more');
// });

// A.19 END ----------------------------------------------------------------------------------------------------------

// A.20 RELATED ARTICLES - LOAD MORE --------------------------------------------------------------

// $(".o-related-articles article").slice(0, 3).show();
// if ($(".o-related-articles article:hidden").length != 0) {
//   $("#js--loadMore").show();
// }

// $("#js--loadMore").on("click", function (e) {
//   e.preventDefault();
//   $(".o-related-articles article:hidden").slice(0, 4).slideDown();
//   if ($(".o-related-articles article:hidden").length == 0) {
//     $("#js--loadMore").fadeOut("slow");
//   }
// });

// A.20 END ----------------------------------------------------------------------------------------------------------

// UNIT LEVEL FEATURES - LOAD MORE START --------------------------------------------------------------

// var unitLevelFeatureCards = $(
//   ".o-2021-units-page .m-unit-features .m-features"
// );

// if (unitLevelFeatureCards.find(".m-feature").length > 8) {
//   $(".o-2021-units-page .m-unit-features").append(
//     "<a class='a-cta _more' href='#'>View more</a>"
//   );
// }

// function hideUnitLevelFeatureCards() {
//   $(".o-2021-units-page .m-unit-features .m-features .m-feature")
//     .slice(0, 8)
//     .addClass("shown");
//   $(".o-2021-units-page .m-unit-features .m-features .m-feature")
//     .not(".shown")
//     .hide();
// }
// hideUnitLevelFeatureCards();

// $(".o-2021-units-page .m-unit-features .a-cta._more").on("click", function (e) {
//   e.preventDefault();
//   $(".o-2021-units-page .m-unit-features .m-features .m-feature")
//     .not(".shown")
//     .toggle(300);
//   $(this).toggleClass("_showless");
//   if ($(this).hasClass("_showless")) {
//     $(this).text("View less");
//   } else {
//     $(this).text("View more");
//   }
// });
// UNIT LEVEL FEATURES - LOAD MORE END --------------------------------------------------------------

// 2021 BUILDING FEATURES - LOAD MORE START --------------------------------------------------------------

// var buildingFeatureCards = $(".o-building-features .m-features");

// if (buildingFeatureCards.find(".m-feature").length > 8) {
//   $(".o-building-features").append(
//     "<a class='a-cta _more' href='#'>View more</a>"
//   );
// }

// function hideBuildingFeatureCards() {
//   $(".o-2021-units-page .m-unit-features .m-features .m-feature")
//     .slice(0, 8)
//     .addClass("shown");
//   $(".o-2021-units-page .m-unit-features .m-features .m-feature")
//     .not(".shown")
//     .hide();
// }
// hideBuildingFeatureCards();

// $(".o-building-features .a-cta._more").on("click", function (e) {
//   e.preventDefault();
//   $(".o-building-features .m-feature").not(".shown").toggle(300);
//   $(this).toggleClass("_showless");
//   if ($(this).hasClass("_showless")) {
//     $(this).text("View less");
//   } else {
//     $(this).text("View more");
//   }
// });

// 2021 BUILDING FEATURES - LOAD MORE END --------------------------------------------------------------

// $('.m-card .a-copy').each(function() {
//   $( this ).parent().addClass( "a-expand" );
// });

// A.20 BUILDING FEATURES MODAL + VIRTUAL TOUR ----------------------------------------------------------------------------------------------------------

$(
  ".o-marketing-page-hero .a-cta-left, .o-features .a-gallery, .a-building-gallery"
).on("click", function (e) {
  e.preventDefault();
  $("body").addClass("gallery-open");
  // if($('html').hasClass('mobile')){
  // e.stopPropagation();
  // var featuresContainer = $('.o-features');
  // $('html,body').animate({scrollTop:featuresContainer.offset().top - $('.o-header').height()}, 1000,'swing');
  // }
  //else {
  // var modalFeatures = $('.o-features .m-container-wrap').html();
  // $('#o-features').on('shown.bs.modal', function() {
  //  $('#o-features').find('.modal-body').html(modalFeatures);
  //});
  //}
});

$(
  "#o-gallery-marketing-modal, #o-gallery-apartment-features-modal, #o-gallery-building-features-modal, #o-gallery-unit-modal"
).on("hidden.bs.modal", function (e) {
  $("body").removeClass("gallery-open");
  $("body").removeClass("mobile-message");
});

$(".o-2021-modal").on("shown.bs.modal", function (e) {
  $(".b-lazy").each(function () {
    var img = $(this);
    img.attr("src", img.data("src"));
  });
});

// Show landscape suggestion popup on mobile START

if (window.innerHeight > window.innerWidth) {
  $(
    "#o-gallery-marketing-modal, #o-gallery-building-features-modal, #o-gallery-unit-modal"
  ).on("shown.bs.modal", function (e) {
    $("#o-mobile-message").modal("show");
    $("body").addClass("mobile-message");
  });

  $("#o-mobile-message").on("hidden.bs.modal", function (e) {
    $("body").removeClass("mobile-message");
  });

  $(".o-video .modal-dialog .modal-content .modal-header .close").css(
    "right",
    "0"
  );
  $(".o-video .modal-dialog .modal-content .modal-header .close").css(
    "top",
    "0"
  );
} else {
  $(".o-video .modal-dialog .modal-content .modal-header .close").css(
    "right",
    "-15px"
  );
  $(".o-video .modal-dialog .modal-content .modal-header .close").css(
    "top",
    "15px"
  );
}

window.addEventListener(
  "resize",
  function () {
    // Get screen size (inner/outerWidth, inner/outerHeight)
    if (window.innerHeight < window.innerWidth) {
      $("#o-mobile-message").modal("hide");
      $("body").removeClass("mobile-message");
      $(".o-video .modal-dialog .modal-content .modal-header .close").css(
        "right",
        "-15px"
      );
      $(".o-video .modal-dialog .modal-content .modal-header .close").css(
        "top",
        "15px"
      );
    } else {
      $(".o-video .modal-dialog .modal-content .modal-header .close").css(
        "right",
        "0"
      );
      $(".o-video .modal-dialog .modal-content .modal-header .close").css(
        "top",
        "0"
      );
    }
  },
  false
);

// Show landscape suggestion popup on mobile END

// $(".o-marketing-page-hero .a-cta-right:not(.a-virtual-tour)").on("click", function(e) {
// $(".o-marketing-page-hero .a-cta-right.a-features").on("click", function (e) {
//   e.preventDefault();
//   e.stopPropagation();
//   var featuresContainer = $(".o-features");
//   $("html,body").animate(
//     { scrollTop: featuresContainer.offset().top - $(".o-header").height() },
//     1000,
//     "swing"
//   );
// });

// $(".o-marketing-page-hero .a-cta-right:not(.a-features)").on(
//   "click",
//   function (e) {
//     e.preventDefault();
//     e.stopPropagation();
//     var dest = $(this).attr("href");
//     $("html,body").animate(
//       { scrollTop: $(dest).offset().top - $(".o-header").height() },
//       1000,
//       "swing"
//     );
//   }
// );

// $(".o-scroll-to .a-scroll").on("click", function (e) {
//   e.preventDefault();
//   e.stopPropagation();
//   var dest = $(this).attr("href");
//   $("html,body").animate(
//     { scrollTop: $(dest).offset().top - $(".o-header").height() },
//     1000,
//     "swing"
//   );
// });

// $(".o-marketing-page-hero .a-cta-right").on("click", function(e) {
//     e.preventDefault();
//     e.stopPropagation();
//     var virtualTourContainer = $('.virtual-tour-intro');
//     $('html,body').animate({scrollTop:virtualTourContainer.offset().top - $('.o-header').height()}, 1000,'swing');
// });

// $(".o-marketing-page-hero .a-cta-right.a-virtual-tour").on(
//   "click",
//   function (e) {
//     e.preventDefault();

//     if ($("html").hasClass("mobile")) {
//       e.stopPropagation();
//       var virtualTourContainer = $(".virtual-tour-intro");
//       $("html,body").animate(
//         {
//           scrollTop:
//             virtualTourContainer.offset().top - $(".o-header").height(),
//         },
//         1000,
//         "swing"
//       );
//     } else {
//       $("body").addClass("o-virtual");
//       var modalTour = $(".virtual-tour-frame").html();
//       $("#o-virtual-tour").on("shown.bs.modal", function () {
//         $("#o-virtual-tour").find(".iframe-wrap").html(modalTour);
//       });
//     }
//   }
// );

// $("#o-virtual-tour .a-close").on("click", function (e) {
//   $("body").removeClass("o-virtual");
// });

// $("#o-video-search").on("shown.bs.modal", function (e) {
//   $("#o-video-search video").get(0).play();
// });

// $("#o-video-search").on("hidden.bs.modal", function (e) {
//   $("#o-video-search video").get(0).pause();
//   $("#o-video-search video").get(0).currentTime = 0;
// });

// $("#o-video-features").on("shown.bs.modal", function (e) {
//   $("#o-video-features video").get(0).play();
// });

// $("#o-video-features").on("hidden.bs.modal", function (e) {
//   $("#o-video-features video").get(0).pause();
//   $("#o-video-features video").get(0).currentTime = 0;
// });

// $("#o-video-marketing").on("shown.bs.modal", function (e) {
//   $("#o-video-marketing video").get(0).play();
// });

// $("#o-video-marketing").on("hidden.bs.modal", function (e) {
//   $("#o-video-marketing video").get(0).pause();
//   $("#o-video-marketing video").get(0).currentTime = 0;
// });

// $("#o-seo-video").on("shown.bs.modal", function (e) {
//   $("#o-seo-video video").get(0).play();
// });

// $("#o-seo-video").on("hidden.bs.modal", function (e) {
//   $("#o-seo-video video").get(0).pause();
//   $("#o-seo-video video").get(0).currentTime = 0;
// });

// $("#o-2021-video-modal").on("shown.bs.modal", function (e) {
//   $("#o-2021-video-modal video").get(0).play();
// });

// $("#o-2021-video-modal").on("hidden.bs.modal", function (e) {
//   $("#o-2021-video-modal video").get(0).pause();
//   $("#o-2021-video-modal video").get(0).currentTime = 0;
// });

// $(".o-2021-video._building-gallery").on("shown.bs.modal", function (e) {
//   var videoId = "#" + this.id + " video";
//   $(videoId).get(0).play();
// });

// $(".o-2021-video._building-gallery").on("hidden.bs.modal", function (e) {
//   var videoId = "#" + this.id + " video";
//   $(videoId).get(0).pause();
//   $(videoId).get(0).currentTime = 0;
// });

// $(".o-video-component .a-video").controls = false;

setTimeout(function () {
  $(".handle-a a").each(function () {
    if ($(this).attr("data-filter-on") == "true") {
      $(this).parents("li").addClass("active");
    }
  });
}, 5);

$(".o-search-component .m-filters .handle-a a").on("click", function (e) {
  var parent = $(this).parents("li");

  setTimeout(function () {
    if (parent.find('a[data-filter-on="true"]').length == 0) {
      $(parent).removeClass("active");
    } else {
      $(parent).addClass("active");
    }
  }, 5);
});

// function windowWidth(maxLength) {
//   var showChar = maxLength;
//   var ellipsestext = "...";

//   $(".o-whats-coming .m-container .content-wrap .m-card .m-block .a-copy").each(
//     function () {
//       var content = $(this).html();
//       if (content.length > showChar) {
//         var c = content.substr(0, showChar);
//         var h = content;
//         var html =
//           '<div class="truncate-text" style="display:block">' +
//           c +
//           '<span class="moreellipses">' +
//           ellipsestext +
//           '&nbsp;&nbsp;<a href="" class="moreless more">more</a></span></span></div><div class="truncate-text" style="display:none">' +
//           h +
//           '<a href="" class="moreless less">Less</a></span></div>';

//         $(this).html(html);
//       }
//     }
//   );

//   $(".moreless").click(function () {
//     var thisEl = $(this);
//     var cT = thisEl.closest(".truncate-text");
//     var tX = ".truncate-text";

//     if (thisEl.hasClass("less")) {
//       cT.prev(tX).toggle();
//       cT.slideToggle();
//     } else {
//       cT.toggle();
//       cT.next(tX).fadeToggle();
//     }
//     return false;
//   });

//   // $('.o-whats-coming .m-container .content-wrap .m-card .m-block .a-copy').each(function() {

//   //     if($(this).text().length >= maxLength) {
//   //         var text = $(this).text(),
//   //         truncated = text.substr(0,maxLength) +
//   //         '<span class="a-bold more">...</span><span class="text" style="display:none">'+text.substr(maxLength)+'</span>';
//   //         $(this).html(truncated);
//   //     }

//   //     $($(this) + ' .more').on('click', function(e) {
//   //         console.log($(this));
//   //     });
//   // });
// }

// jQuery("#inTouch").on("click", function () {
//   // jQuery('.communication-types').toggle('slow');

//   if (jQuery("#inTouch").is(":checked")) {
//     jQuery(".communication-types input").prop("checked", true);
//   } else {
//     jQuery(".communication-types input").prop("checked", false);
//   }
// });

function topFunction() {
  jQuery("html, body").animate({ scrollTop: 0 }, 500);
}

jQuery(".scroll-to-top").on("click", function () {
  topFunction();
});

window.onscroll = function () {
  scrollFunction();
};

function scrollFunction() {
  if (
    document.body.scrollTop > 350 ||
    document.documentElement.scrollTop > 350
  ) {
    if (jQuery(".scroll-to-top").css("visibility") == "hidden") {
      jQuery(".scroll-to-top").css("visibility", "visible");
    }
  } else {
    jQuery(".scroll-to-top").css("visibility", "hidden");
  }
}

if (document.body.clientWidth < 992) {
  jQuery(".m-menu-items-right").prepend('<div id="mobile-menu-call"></div>');
  jQuery(".o-phone-menu").appendTo("#mobile-menu-call");
}

// function summarizeText() {
//   if (document.body.clientWidth < 992) {
//     windowWidth(10000);
//   } else if (
//     document.body.clientWidth >= 992 &&
//     document.body.clientWidth < 1092
//   ) {
//     windowWidth(225);
//   } else if (
//     document.body.clientWidth >= 1092 &&
//     document.body.clientWidth < 1200
//   ) {
//     windowWidth(265);
//   } else if (
//     document.body.clientWidth >= 1200 &&
//     document.body.clientWidth < 1300
//   ) {
//     windowWidth(180);
//   } else if (
//     document.body.clientWidth >= 1300 &&
//     document.body.clientWidth < 1450
//   ) {
//     windowWidth(200);
//   } else if (
//     document.body.clientWidth >= 1450 &&
//     document.body.clientWidth < 1550
//   ) {
//     windowWidth(220);
//   } else if (
//     document.body.clientWidth >= 1550 &&
//     document.body.clientWidth < 1650
//   ) {
//     windowWidth(230);
//   } else if (
//     document.body.clientWidth >= 1650 &&
//     document.body.clientWidth < 1750
//   ) {
//     windowWidth(250);
//   } else if (
//     document.body.clientWidth >= 1750 &&
//     document.body.clientWidth < 1850
//   ) {
//     windowWidth(285);
//   } else if (
//     document.body.clientWidth >= 1850 &&
//     document.body.clientWidth < 1950
//   ) {
//     windowWidth(310);
//   }
// }

// jQuery(window).on("load", summarizeText);

// A.20 END ----------------------------------------------------------------------------------------------------------

// function scrollIt(destination, duration, easing, callback) {

//   duration = 200;
//   easing = 'linear';

//   const easings = {
//     linear(t) {
//       return t;
//     },
//     easeInQuad(t) {
//       return t * t;
//     },
//     easeOutQuad(t) {
//       return t * (2 - t);
//     },
//     easeInOutQuad(t) {
//       return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
//     },
//     easeInCubic(t) {
//       return t * t * t;
//     },
//     easeOutCubic(t) {
//       return (--t) * t * t + 1;
//     },
//     easeInOutCubic(t) {
//       return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
//     },
//     easeInQuart(t) {
//       return t * t * t * t;
//     },
//     easeOutQuart(t) {
//       return 1 - (--t) * t * t * t;
//     },
//     easeInOutQuart(t) {
//       return t < 0.5 ? 8 * t * t * t * t : 1 - 8 * (--t) * t * t * t;
//     },
//     easeInQuint(t) {
//       return t * t * t * t * t;
//     },
//     easeOutQuint(t) {
//       return 1 + (--t) * t * t * t * t;
//     },
//     easeInOutQuint(t) {
//       return t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * (--t) * t * t * t * t;
//     }
//   };

//   const start = window.pageYOffset;
//   const startTime = 'now' in window.performance ? performance.now() : new Date().getTime();

//   const documentHeight = Math.max(document.body.scrollHeight, document.body.offsetHeight, document.documentElement.clientHeight, document.documentElement.scrollHeight, document.documentElement.offsetHeight);
//   const windowHeight = window.innerHeight || document.documentElement.clientHeight || document.getElementsByTagName('body')[0].clientHeight;
//   const destinationOffset = typeof destination === 'number' ? destination : destination.offsetTop;
//   const destinationOffsetToScroll = Math.round(documentHeight - destinationOffset < windowHeight ? documentHeight - windowHeight : destinationOffset);

//   if ('requestAnimationFrame' in window === false) {
//     window.scroll(0, destinationOffsetToScroll);
//     if (callback) {
//       callback();
//     }
//     return;
//   }

//   function scroll() {
//     const now = 'now' in window.performance ? performance.now() : new Date().getTime();
//     const time = Math.min(1, ((now - startTime) / duration));
//     const timeFunction = easings[easing](time);
//     window.scroll(0, Math.ceil((timeFunction * (destinationOffsetToScroll - start)) + start));

//     if (window.pageYOffset === destinationOffsetToScroll) {
//       if (callback) {
//         callback();
//       }
//       return;
//     }

//     requestAnimationFrame(scroll);
//   }

//   scroll();
// }

// A. END ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
setTimeout(function () {
  if (window.location.hash == "#open-form") {
    jQuery(".a-btn-text").click();
  } else {
    // Fragment doesn't exist
  }
}, 5);

// console.log(module);
// jQuery('.o-whats-coming .m-container .content-wrap .m-card .m-block .a-copy p').each(function(){
//     console.log(jQuery(this));
//     setTimeout(function(){
//         $clamp(jQuery(this).html(), {
//             clamp: 6
//         });
//     }, 5);
// });

// setTimeout(function(){
//     if(jQuery('.m-sub-menu').find('.is-active').length !== 0) {
//         var active_sub = jQuery('.m-sub-menu').find('.is-active');
//         var li_men = jQuery(active_sub).parent();
//         var ul_men = jQuery(li_men).parent();
//         var main_li_men = jQuery(ul_men).parent();
//         jQuery(main_li_men + ' a').addClass('is-active');
//         console.log(active_sub);
//     }
// }, 5);

var getUrlParameter = function getUrlParameter(sParam) {
  var sPageURL = window.location.search.substring(1),
    sURLVariables = sPageURL.split("&"),
    sParameterName,
    i;

  for (i = 0; i < sURLVariables.length; i++) {
    sParameterName = sURLVariables[i].split("=");

    if (sParameterName[0] === sParam) {
      return sParameterName[1] === undefined
        ? true
        : decodeURIComponent(sParameterName[1]);
    }
  }
};

function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

var urlparAlt =
  getUrlParameter("outm_source") + "," + getUrlParameter("outm_medium");
var urlpar =
  getUrlParameter("utm_source") + "," + getUrlParameter("utm_medium");

var utmcookie = getCookie("utmcook");

// console.log('utmcookie',utmcookie);
// console.log('urlPar',urlpar);
// console.log('urlparAlt', urlparAlt);

var expireCookie = new Date();
var expireMinutes = 30;
expireCookie.setTime(expireCookie.getTime() + expireMinutes * 60 * 1000);

// do we have url params
if (urlpar.length > 0 && urlpar.indexOf("undefined,undefined") == -1) {
  // console.log('urlpar');
  // do we have an existing cookie that's different from our new value
  if (utmcookie.length > 0 && utmcookie != urlpar) {
    // console.log('utmcookie.length && utmcookie != urlpar');
    document.cookie =
      "utmcook=" + urlpar + ";expires=" + expireCookie.toUTCString();
    localStorage.setItem("usersrc", urlpar);
  } else if (utmcookie.length > 0) {
    localStorage.setItem("usersrc", utmcookie);
  }
  var testSrc = localStorage.getItem("usersrc");
  if (testSrc === null) {
    localStorage.setItem("usersrc", urlpar);
    document.cookie =
      "utmcook=" + urlpar + ";expires=" + expireCookie.toUTCString();
  }
} else if (
  urlparAlt.length > 0 &&
  urlparAlt.indexOf("undefined,undefined") == -1
) {
  // console.log('else urlparAlt');
  // do we have an existing cookie
  if (utmcookie.length > 0 && utmcookie != urlparAlt) {
    // console.log('utmcookie.length && utmcookie != urlparAlt');
    document.cookie =
      "utmcook=" + urlparAlt + ";expires=" + expireCookie.toUTCString();
    localStorage.setItem("usersrc", urlparAlt);
  } else if (utmcookie.length > 0) {
    localStorage.setItem("usersrc", utmcookie);
  }
  var testSrc = localStorage.getItem("usersrc");
  if (testSrc === null) {
    localStorage.setItem("usersrc", urlparAlt);
    document.cookie =
      "utmcook=" + urlparAlt + ";expires=" + expireCookie.toUTCString();
  }
} else {
  // console.log('else');
  // do we have an existing cookie
  if (utmcookie.length === 0) {
    // console.log('utmcookie.length == 0');
    var cookieval = getCookie("__adal_ca");
    if (cookieval.length > 0) {
      var cookstrings = JSON.stringify(cookieval);
      var splitter = cookstrings.split("&");
      var cookiesrc = splitter[0].split("=");
      var cookiemed = splitter[1].split("=");
      var combcookie = cookiesrc[1] + "," + cookiemed[1];
      document.cookie =
        "utmcook=" + combcookie + ";expires=" + expireCookie.toUTCString();
      localStorage.setItem("usersrc", combcookie);
    } else {
      localStorage.setItem("usersrc", "direct,none");
    }
  } else {
    localStorage.setItem("usersrc", utmcookie);
  }
}

// if (utmcookie.length > 0) {
// } else {
//   var now = new Date();
//   var minutes = 30;
//   now.setTime(now.getTime() + (minutes * 60 * 1000));
//
//   if(urlpar.length > 0) {
//     if (urlpar.indexOf("undefined,undefined") >= 0) {
//       var cookieval = getCookie('__adal_ca');
//       if(cookieval.length > 0) {
//         var cookstrings = JSON.stringify(cookieval);
//         var splitter = cookstrings.split("&");
//         var cookiesrc = splitter[0].split("=");
//         var cookiemed = splitter[1].split("=");
//         var combcookie = cookiesrc[1] + ',' + cookiemed[1];
//         document.cookie = "utmcook="+combcookie+";expires="+now.toUTCString();
//       }
//     } else {
//       document.cookie = "utmcook="+urlpar+";expires="+now.toUTCString();
//     }
//   }
//
// }

// setTimeout(function () {
// console.log("HERE");
// var lastVisit = localStorage.getItem('lastvisit');
// localStorage.setItem('lastvisit', new Date().getTime());
// var userSrc = localStorage.getItem("usersrc");
// jQuery('[name="custom_source"]').each(function () {
//   jQuery(this).val(userSrc);
// });
// 3600 * 1000 = 1 hour since last visit
// var newVisit = userSrc === null || userSrc.trim() === '' || lastVisit === null || new Date().getTime() - lastVisit > (3600 * 1000);
// console.log('newVisit', newVisit);
// console.log(utmcookie);
// console.log(utmcookie.indexOf("undefined") >= 0);
// if (utmcookie.indexOf("undefined") >= 0) {
//   jQuery('[name="custom_source"]').each(function () {
//     if (urlparAlt.length > 0 && urlparAlt.indexOf("undefined,undefined") == -1) {
//       jQuery(this).val(urlparAlt);
//     }
//     else {
//       jQuery(this).val(urlpar);
//     }
//     // if (newVisit) {
//     //   localStorage.setItem('usersrc', urlpar);
//     // }
//   });
// }
// else {
//   jQuery('[name="custom_source"]').each(function () {
//     jQuery(this).val(utmcookie);
//     // if (newVisit) {
//     //   localStorage.setItem('usersrc', utmcookie);
//     // }
//   });
// }
// }, 2000);

// @TODO REMOVE THIS ONCE THE CALENDARS ARE MOVED TO THEIR INDIVIDUAL SCREENS JS FILES
// jQuery(".slot").on("click", function () {
//   jQuery(".timeslots .slot").removeClass("active-slot");
//   jQuery(this).addClass("active-slot");
// });

// jQuery(".parking-item").on("click", function () {
//   jQuery(".parking-selector .parking-item").removeClass("active-parking-item");
//   jQuery(this).addClass("active-parking-item");
// });

// jQuery(".selected-pet-quant").on("click", function (e) {
//   var selector = jQuery(this).parent().find(".pet-quant-select");
//   jQuery(selector).show();
// });

// jQuery(".pet-quant-select li").on("click", function (e) {
//   var container = jQuery(".pet-quant-select");
//   var selectorVal = jQuery(this).attr("data-value");
//   var selectorTextVal = jQuery(this).text();
//   var quantitytoUpdate = jQuery(this)
//     .parent()
//     .parent()
//     .find(".selected-pet-quant");
//   jQuery(quantitytoUpdate).text(selectorTextVal);
//   jQuery(quantitytoUpdate).attr("data-pet-amount", selectorVal);
//   // console.log(selectorVal);
//   jQuery(this).parent().css("display", "none");

//   if (selectorVal > 0) {
//     jQuery(quantitytoUpdate).addClass("selected");
//   } else {
//     jQuery(quantitytoUpdate).removeClass("selected");
//   }

//   jQuery(".cat-price").text(jQuery(".amountCat").attr("data-pet-amount"));
//   jQuery(".small-animal-price").text(
//     jQuery(".amountSmall").attr("data-pet-amount")
//   );
//   jQuery(".dog-price").text(jQuery(".amoutDog").attr("data-pet-amount"));
// });

// jQuery(document).mouseup(function (e) {
//   var container = jQuery(".pet-quant-select");

//   // if the target of the click isn't the container nor a descendant of the container
//   if (!container.is(e.target) && container.has(e.target).length === 0) {
//     container.hide();
//   }
// });

// jQuery(".cancel-process").on("click", function (e) {
//   jQuery("#reserveModal .close").click();
//   jQuery(".o-reserve-process .reservation-step-holder-item").hide();
//   jQuery(".book-a-viewing-date").show();
// });

jQuery("#reserveModal .close").on("click", function (e) {
  jQuery(".o-reserve-process .reservation-step-holder-item").hide();
  jQuery(".book-a-viewing-date").show();
});

// jQuery(".show-acc-create").on("click", function (e) {
//   jQuery(".o-reserve-process .reservation-step-holder-item").hide();
//   jQuery(".o-create-account-tipi").show();
// });

// jQuery('.save-profile').on('click', function(e) {
//
//   var validation = validate_acc_edit();
//   if (validation) {
//     SaveAccDetails();
//   }
// });

// jQuery(".show-step-one").on("click", function (e) {
//   var validation = validate_acc_creation_popup();

//   if (validation == true) {
//     if (window.location.pathname.indexOf("viewing") >= 0) {
//       create_lead_on_register("booking");
//     } else if (window.location.pathname.indexOf("reserve") >= 0) {
//       create_lead_on_register("reservation");
//     }
//   }
// });

// jQuery('.show-step-two').on('click', function(e){
//   var day = jQuery('#reserve-calendar').datepicker('getDate').getDate();
//   var month = jQuery('#reserve-calendar').datepicker('getDate').getMonth() + 1;
//   var year = jQuery('#reserve-calendar').datepicker('getDate').getFullYear();
//
//   var reservationDate = day+" "+month+" "+year;
//   var leaseTerm = jQuery('.active-term strong').text();
//
//   var reservationStepOne = { 'reservationDate': reservationDate,  'leaseTerm':leaseTerm};
//
//   // Put the object into storage
//   localStorage.setItem('reservationStepOne', JSON.stringify(reservationStepOne));
//
//   get_ancilliries();
//
// });

// jQuery('.show-payment-step').on('click', function(e){
//   jQuery('.o-reserve-process .reservation-step-holder-item').hide('slow');
//   jQuery('.o-reserve-payment-step').show('slow');
//
//   var selectedParking = jQuery('.active-parking-item strong').text();
//   var animalsDog = jQuery('.amoutDog').text().split('');
//   var animalsCat = jQuery('.amountCat').text().split('');
//   var animalsSmall = jQuery('.amountSmall').text().split('');
//
//   var reservationStepTwo = { 'selectedParking': selectedParking,  'animalsDog':animalsDog[0], 'animalsCat':animalsCat[0], 'animalsSmall':animalsSmall[0] };
//
//   localStorage.setItem('reservationStepTwo', JSON.stringify(reservationStepTwo));
//
//   var flowObject = JSON.parse(localStorage.getItem('flowObject'));
//   var StepOne = JSON.parse(localStorage.getItem('reservationStepOne'));
//   var StepTwo = JSON.parse(localStorage.getItem('reservationStepTwo'));
//
//   // jQuery('.selected-apartment-details .unit-name').text(flowObject['unitNumber']+" "+flowObject['unitBuilding']);
//   // jQuery('.selected-apartment-details .unit-price strong').text("£"+flowObject['unitRent']);
//   if(StepTwo['animalsDog'] === '0') {
//     dogs = '';
//   } else {
//     if (StepTwo['animalsDog'] > 1) {
//       var dogString = " Dogs ";
//     } else {
//       var dogString = " Dog ";
//     }
//     var dogs = " | "+StepTwo['animalsDog']+ dogString;
//   }
//
//   if(StepTwo['animalsCat'] === '0') {
//     cats = '';
//   } else {
//     if (StepTwo['animalsCat'] > 1) {
//       var catString = " Cats ";
//     } else {
//       var catString = " Cat ";
//     }
//     var cats = " | "+StepTwo['animalsCat']+catString;
//   }
//
//   if(StepTwo['animalsSmall'] === '0') {
//     smallanimals = '';
//   } else {
//     if (StepTwo['animalsSmall'] > 1) {
//       var smlAnimalString = " Small Animals ";
//     } else {
//       var smlAnimalString = " Small Animal ";
//     }
//     var smallanimals = " | "+StepTwo['animalsSmall'] + smlAnimalString;
//   }
//
//
//   jQuery('.selected-apartment-details .unit-specs').text(flowObject['unitBeds']+" | "+flowObject['unitFurn']+" | "+flowObject['unitSize']+"sqm "+cats+dogs+smallanimals+" | "+StepTwo['selectedParking']);
//   // jQuery('.selected-apartment-image').css('background-image', 'url(' + flowObject['unitImage'] + ')');
// });

// jQuery('.show-viewing-confirmation').on('click', function(e){
//
//   var day = jQuery('#book-a-viewing-calendar').datepicker('getDate').getDate();
//   var month = jQuery('#book-a-viewing-calendar').datepicker('getDate').getMonth() + 1;
//   var year = jQuery('#book-a-viewing-calendar').datepicker('getDate').getFullYear();
//
//   if(month < 10) {
//     var newmonth = '0'+month;
//   } else {
//     var newmonth = month;
//   }
//
//
//   var viewingDate = day+" "+newmonth+" "+year;
//   var timeSlot = jQuery('.active-slot').text();
//   var viewingPref = jQuery('input[name="viewing-method"]:checked').val();
//   var flowObject = JSON.parse(localStorage.getItem('flowObject'));
//   var viewingDataObject = { 'viewingDate': viewingDate,  'timeSlot':timeSlot,  'viewingPref':viewingPref};
//
//   // Put the object into storage
//   localStorage.setItem('viewingDataObject', JSON.stringify(viewingDataObject));
//
//   // D d M Y
//   $.post(
//     '/olj-date',
//     {
//       Date: year+'-'+newmonth+'-'+day ,
//       Format: 'D d M Y'
//     },
//     function(data) {
//       jQuery('.confirmation-message .selected-date').text(data.date);
//     }
//   );
//   jQuery('.confirmation-message .selected-timeslot').text(timeSlot);
//   createBooking();
//
// });

// jQuery('.show-res-confirmed').on('click', function(e){
// var validation = validate_booking_terms();
// if (validation) {
// var flowObject = JSON.parse(localStorage.getItem('flowObject'));
// jQuery('.desktop-right-column .unit-image').css('background-image', 'url(' + flowObject['unitImage'] + ')');
// jQuery('.left-col-desltop .unit-image').css('background-image', 'url(' + flowObject['unitImage'] + ')');
// reserve_unit();
// });

//Reservation Flow Object

jQuery(".data-flow").on("click", function () {
  var flowType = jQuery(this).attr("data-flow");
  var unitSize = jQuery(this).attr("data-unit-size");
  var unitRent = jQuery(this).attr("data-unit-rent");
  var unitFurn = jQuery(this).attr("data-unit-furnished");
  var unitBeds = jQuery(this).attr("data-unit-beds");
  var unitImage = jQuery(this).attr("data-unit-image");
  var unitName = jQuery(this).attr("data-unit-name");
  var unitNID = jQuery(this).attr("data-nid");

  var r = /\d+/;
  var str = unitName;
  var x = $.trim(str.match(r).toString());
  var str_split = str.split(x);
  var arr = [];
  $.each(str_split, function (i, val) {
    arr.push($.trim(val));
    arr.push(x.toString());
  });
  arr.pop();

  var flowObject = {
    flowType: flowType,
    unitSize: unitSize,
    unitRent: unitRent,
    unitFurn: unitFurn,
    unitBeds: unitBeds,
    unitImage: unitImage,
    unitNumber: arr[1],
    unitBuilding: arr[2],
    unitNid: unitNID,
  };

  // Put the object into storage
  localStorage.setItem("flowObject", JSON.stringify(flowObject));

  user_status_check();
});

jQuery(".building").hover(function () {
  jQuery(this).toggleClass("open-building");
});

// jQuery(".show-acc-res").on("click", function () {
//   jQuery(".m-profile-blob").show();
//   jQuery(".m-upcommings-viewing").hide();
//   jQuery(".m-find-a-home").hide();
//   jQuery(".m-edit-profile").hide();
//   jQuery(".m-finalize-reservation").show();
// });

// jQuery(".show-viewing-res").on("click", function () {
//   jQuery(".m-profile-blob").show();
//   jQuery(".m-upcommings-viewing").show();
//   jQuery(".m-find-a-home").hide();
//   jQuery(".m-edit-profile").hide();
//   jQuery(".m-finalize-reservation").hide();
// });

// jQuery(".show-acc-find-home").on("click", function () {
//   jQuery(".m-profile-blob").show();
//   jQuery(".m-upcommings-viewing").hide();
//   jQuery(".m-find-a-home").show();
//   jQuery(".m-edit-profile").hide();
//   jQuery(".m-finalize-reservation").hide();
// });

// jQuery(".show-acc-edit").on("click", function () {
//   jQuery(".m-profile-blob").hide();
//   jQuery(".m-upcommings-viewing").hide();
//   jQuery(".m-find-a-home").hide();
//   jQuery(".m-edit-profile").show();
//   jQuery(".m-finalize-reservation").hide();
// });

// jQuery(".info-icon").on("click", function () {
//   jQuery(".info-icon-content").hide("slow");
//   var infocontent = jQuery(this).find(".info-icon-content");
//   jQuery(infocontent).toggle("slow");
// });

// jQuery(document).mouseup(function (e) {
//   var container = jQuery(".info-icon");

//   // if the target of the click isn't the container nor a descendant of the container
//   if (!container.is(e.target) && container.has(e.target).length === 0) {
//     jQuery(".info-icon-content").hide("slow");
//   }
// });

jQuery("#auth0-login-container").on("DOMNodeInserted", function (e) {
  // console.log('button is ready');

  if (
    jQuery(
      "button[data-provider=google-oauth2] .auth0-lock-social-button-text"
    ).text() === "Log in with Google"
  ) {
    jQuery(
      "button[data-provider=google-oauth2] .auth0-lock-social-button-text"
    ).text("Continue with Google");
  }

  if (
    jQuery(
      "button[data-provider=facebook] .auth0-lock-social-button-text"
    ).text() === "Log in with Facebook"
  ) {
    jQuery(
      "button[data-provider=facebook] .auth0-lock-social-button-text"
    ).text("Continue with Facebook");
  }

  if (
    jQuery(
      "button[data-provider=apple] .auth0-lock-social-button-text"
    ).text() === "Log in with Apple"
  ) {
    jQuery("button[data-provider=apple] .auth0-lock-social-button-text").text(
      "Continue with Apple"
    );
  }
});

setTimeout(function () {
  jQuery(".auth0-lock-form").find('.auth-lock-social-buttons-pane').siblings().remove();
  jQuery(".auth0-lock-widget-container").find('.auth0-lock-submit').remove();
}, 3000);
// if (document.getElementById('book-a-viewing-calendar')) {
//   jQuery( "#book-a-viewing-calendar" ).datepicker({
//     minDate: 3,
//     onSelect: function(dateText) {
//       var splitter = this.value.split("/");
//       var oljdate = splitter[2]+'-'+splitter[0]+'-'+splitter[1];
//       get_booking_avail_slot(oljdate);
//       jQuery('body').addClass('calendar-loaded');
//       jQuery('.book-a-viewing-date .book-a-viewing-info .generic-validation').remove();
//     }
//   });
// } else {
//   // do stuff
// }

// A.21 STICKY HEADER START ----------------------------------------------------------------------------------------------------------
var stickyOffset = $(".o-header").offset().top,
  sticky = $(".o-header");
if ($(".o-header").length) {
  if (
    $("body").hasClass("adminimal-admin-toolbar") &&
    !$("body").hasClass("toolbar-tray-open")
  ) {
    stickyOffset -= 39;
  } else if (
    $("body").hasClass("adminimal-admin-toolbar") &&
    $("body").hasClass("toolbar-tray-open")
  ) {
    stickyOffset -= 79;
  }
}
$(window)
  .on("resize", function () {
    if ($(".o-header").length) {
      $(window).scroll(function () {
        var scroll = $(window).scrollTop();
        if (scroll > stickyOffset) {
          $("html").addClass("fixed-nav");
          sticky.addClass("fixed-top");
        } else {
          $("html").removeClass("fixed-nav");
          sticky.removeClass("fixed-top");
        }
      });
    }
    if ($(".o-2021-image-carousel").length) {
      var imageCarousel = $(".o-2021-image-carousel");
      var scrolled = false;
      $(window).scroll(function () {
        var top_of_element = imageCarousel.offset().top;
        var bottom_of_element =
          imageCarousel.offset().top + imageCarousel.outerHeight();
        var bottom_of_screen = $(window).scrollTop() + $(window).innerHeight();
        var top_of_screen = $(window).scrollTop();
        if (
          bottom_of_screen > top_of_element &&
          top_of_screen < bottom_of_element &&
          !scrolled
        ) {
          scrolled = true;
          setTimeout(function () {
            $(".o-2021-image-carousel .m-2021-image-carousel").trigger(
              "next.owl"
            );
          }, 350);
        }
      });
    }
  })
  .resize();

// A.21 END ----------------------------------------------------------------------------------------------------------

// 2021 STICKY UNIT PAGE DETAIL CONTROLS START

var $sticky = $(".m-block._mobile");
var $scrollToTop = $(".scroll-to-top");
if ($sticky.length && window.innerWidth < 768) {
  var stickytop = $(window).height() + 80; // $sticky.offset().top;

  $(window).scroll(function () {
    var scroll = $(window).scrollTop() + $(window).height();

    if (scroll >= stickytop) {
      $sticky.addClass("sticky");
      $scrollToTop.css("bottom", "105px");
    } else {
      $sticky.removeClass("sticky");
      $scrollToTop.css("bottom", "5%");
    }
  });
}

// 2021 STICKY UNIT PAGE DETAIL CONTROLS END

// A.22 LOAD BLAZY PLUGIN ----------------------------------------------------------------------------------------------------------

var bLazy = new Blazy({
  breakpoints: [
    {
      width: 767, // max-width
      src: "data-src-small",
    },
    {
      width: 768, // max-width
      src: "data-src-medium",
    },
  ],
});

jQuery(".owl-carousel").on("changed.owl.carousel", bLazy.revalidate);

$(".o-2021-building-gallery .m-thumbnail").click(function () {
  bLazy.revalidate();
});
// A.22 END ----------------------------------------------------------------------------------------------------------

// A.23 READ MORE/LESS START ----------------------------------------------------------------------------------------------------------
var maxHeight;
function showReadMore() {
  $this = jQuery(".m-copy-wrap .m-copy");
  var benefitCount = jQuery(
    ".o-seo-benefits-listing .m-block-wrap .m-block"
  ).length;
  if ($this) {
    jQuery(".m-copy-wrap .m-copy").each(function () {
      var parent = jQuery(this).parent();
      var cta = parent.next();
      if (jQuery($this).height() > jQuery($this).parent().height()) {
        cta.css({ display: "inline-block" });
      } else {
        cta.css({ display: "none" });
      }
    });
  }
  if (benefitCount > 4) {
    var count = 0;
    var wrapper = jQuery(".o-seo-benefits-listing .m-block-wrap");
    jQuery(".o-seo-benefits-listing .m-cta-wrap").addClass("show");
    if (jQuery(window).width() <= 767) {
      maxHeight =
        jQuery(".o-seo-benefits-listing .m-block-wrap .m-block").innerHeight() *
        2;
    } else {
      maxHeight = jQuery(
        ".o-seo-benefits-listing .m-block-wrap .m-block"
      ).innerHeight();
    }
    wrapper.css("max-height", maxHeight);
  }
}
showReadMore();
jQuery(window).on("load", function () {
  showReadMore();
});

jQuery(".o-seo-benefits-listing .a-cta").on("click", function (e) {
  e.preventDefault();
  if (jQuery(this).text() == "Show me more") {
    //   //jQuery("#expand-copy").removeAttr('id');
    jQuery(this).text("Show me less");
    jQuery(this).removeClass("_down-arrow");
    jQuery(this).addClass("_up-arrow");
    jQuery(".o-seo-benefits-listing .m-block-wrap").css(
      "max-height",
      "inherit"
    );
  } else {
    jQuery(this).text("Show me more");
    jQuery(this).addClass("_down-arrow");
    jQuery(this).removeClass("_up-arrow");
    jQuery(".o-seo-benefits-listing .m-block-wrap").css(
      "max-height",
      maxHeight
    );
  }
});

jQuery(".js--show-more").on("click", function (e) {
  e.preventDefault();
  var copy = jQuery(this).prev();
  //jQuery(this).text((jQuery(this).text() == 'Show me more') ? 'Show me less' : 'Show me more');
  if (jQuery(this).text() == "Show me more") {
    //   //jQuery("#expand-copy").removeAttr('id');
    jQuery(this).text("Show me less");
    jQuery(this).removeClass("_down-arrow");
    jQuery(this).addClass("_up-arrow");
    copy.addClass("open");
  } else {
    jQuery(this).text("Show me more");
    jQuery(this).addClass("_down-arrow");
    jQuery(this).removeClass("_up-arrow");
    copy.removeClass("open");
  }
});

// A.23 END ----------------------------------------------------------------------------------------------------------

// A.24 SEO HEADER SLIDER START ----------------------------------------------------------------------------------------------------------

jQuery(".o-seo-page-hero .m-cta-wrap .a-cta[href*='#']").each(function () {
  jQuery(this).addClass("_down-arrow");
  jQuery(this).on("click", function (e) {
    e.preventDefault();
    e.stopPropagation();
    var dest = jQuery(this).attr("href");
    jQuery("html,body").animate(
      { scrollTop: $(dest).offset().top - $(".o-header").height() },
      1000,
      "swing"
    );
  });
});

// A.24 END ----------------------------------------------------------------------------------------------------------

// A.25 EQUAL HEIGHTS START ----------------------------------------------------------------------------------------------------------

var equalheight;
equalheight = function (container) {
  var currentTallest = 0,
    currentRowStart = 0,
    topPosition = 0,
    currentDiv = 0,
    rowDivs = [],
    $el;
  $(container).each(function () {
    $el = $(this);
    $($el).height("auto");
    topPosition = $el.position().top;

    if (currentRowStart !== topPosition) {
      for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
        rowDivs[currentDiv].height(currentTallest);
      }
      rowDivs.length = 0; // empty the array
      currentRowStart = topPosition;
      currentTallest = $el.height();
      rowDivs.push($el);
    } else {
      rowDivs.push($el);
      currentTallest =
        currentTallest < $el.height() ? $el.height() : currentTallest;
    }
    for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
      rowDivs[currentDiv].height(currentTallest);
    }
  });
};
var textLength = 0;
if (jQuery(window).width() > 767 && jQuery(window).width() < 1024) {
  textLength = 75;
} else if (jQuery(window).width() >= 1024 && jQuery(window).width() < 1100) {
  textLength = 60;
} else if (jQuery(window).width() >= 1100 && jQuery(window).width() < 1200) {
  textLength = 55;
} else if (jQuery(window).width() >= 1200) {
  textLength = 95;
}

if (jQuery(window).width() > 767) {
  jQuery(".o-seo-landing-page-widgets .m-body .a-copy").each(function () {
    var title = jQuery(this).text();
    if (title.length > textLength) {
      var shortText =
        jQuery
          .trim(title)
          .substring(0, textLength)
          .split(" ")
          .slice(0, -1)
          .join(" ") + "...";
      jQuery(this).text(shortText);
    }
  });
}

// 2021 - Homeviews carousel character limit START
var homeviewsTitleLength = 200;
var homeviewsDescriptionLength = 200;
jQuery(".o-2021-homeviews-carousel .m-body .a-title").each(function () {
  var title = jQuery(this).text();
  if (title.length > homeviewsTitleLength) {
    var shortText =
      jQuery
        .trim(title)
        .substring(0, homeviewsTitleLength)
        .split(" ")
        .slice(0, -1)
        .join(" ") + "...";
    jQuery(this).text(shortText);
  }
});
jQuery(".o-2021-homeviews-carousel .m-body .a-copy").each(function () {
  var title = jQuery(this).text();
  if (title.length > homeviewsDescriptionLength) {
    var shortText =
      jQuery
        .trim(title)
        .substring(0, homeviewsDescriptionLength)
        .split(" ")
        .slice(0, -1)
        .join(" ") + "...";
    jQuery(this).text(shortText);
  }
});
// 2021 - Homeviews carousel character limit END

jQuery(window).on("load", function () {
  if (jQuery(window).width() > 767) {
    equalheight(".o-seo-landing-page-widgets .m-card .m-body");
    equalheight(".o-apartment-listing .o-unit-card .m-card-body");
    // equalheight(".o-grid-apartments .m-card .m-body");
  }
  equalheight(
    ".o-dashboard-viewings .m-cards._multiple .o-unit-card .m-card-body"
  );
});

var resizeTimer;
$(window).resize(function () {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(function () {
    if (window.innerWidth > 767) {
      equalheight(".o-seo-landing-page-widgets .m-card .m-body");
      equalheight(".o-apartment-listing .o-unit-card .m-card-body");
      // equalheight(".o-grid-apartments .m-card .m-body");
    }
    equalheight(
      ".o-dashboard-viewings .m-cards._multiple .o-unit-card .m-card-body"
    );
  }, 250);
});

// A.25 END ----------------------------------------------------------------------------------------------------------

// A.26 SEO PAGE UNIT FILTER START ----------------------------------------------------------------------------------------------------------

jQuery(".o-facelift-search-block .o-seo-show-more .a-link").text(
  "Show me more"
);

jQuery(".m-filter-wrap .a-cta").on("click", function (e) {
  e.preventDefault();
  e.stopPropagation();
  jQuery(this).parent().toggleClass("open");
  if (jQuery(this).parent().hasClass("open")) {
    jQuery(".m-filter-wrap .a-cta").removeClass("_down-arrow");
    jQuery(".m-filter-wrap .a-cta").addClass("_up-arrow");
  } else {
    jQuery(".m-filter-wrap .a-cta").removeClass("_up-arrow");
    jQuery(".m-filter-wrap .a-cta").addClass("_down-arrow");
  }
});

if (jQuery(window).width() > 767) {
  jQuery(".features-included span").on("click", function (e) {
    jQuery(this).toggleClass("open");
  });
}

setTimeout(function () {
  if (jQuery(".preselected-filters")[0]) {
    jQuery(".a-btn-clear").click();
    jQuery(".pr-filt").each(function (i, obj) {
      var filt = jQuery(obj).text();
      jQuery(".o-search-component " + filt).click();
    });
  } else {
    // are we coming from the CTA bar (TIPIS-755)
    var fromCTA = localStorage.getItem("tipi-filters-lfcta");
    if ((typeof fromCTA == "undefined" || !fromCTA) && !preFilter) {
      // console.log('clearing filters');
      jQuery(".a-btn-clear").click();
    } else {
      setTimeout(function () {
        localStorage.setItem("tipi-filters-lfcta", false);
      }, 2000);
    }
  }
}, 1500);

// A.26 END ----------------------------------------------------------------------------------------------------------

// A.27. STAR RATINGS -------------------------------------------------------------------------------------------------------
jQuery(".m-star-rating").each(function () {
  var val = jQuery(this).find(".a-value").text();
  var filledBar = jQuery(this).find(".a-filled");

  var calc = (val / 5) * 100 + "%";
  filledBar.css("width", calc);
});
// A.27. END -----------------------------------------------------------------------------------------------------------

// A.28. STICKY BUTTONS IN UNIT HERO

if (document.body.clientWidth <= 991) {
  var stiky = $(".o-unit-hero .m-sticky");
  var stikyWrap = $(".o-unit-hero .m-sticky-wrap");
  var startSticky,
    scrollTop = 0;
  var stickyButtons = function () {
    if (stiky.length !== 0) {
      startSticky =
        stikyWrap.offset().top -
        $(".o-header").outerHeight() +
        $(".o-unit-hero .m-sticky-wrap").outerHeight() +
        17;
      scrollTop =
        window.pageYOffset !== undefined
          ? window.pageYOffset +
            $(window).height() -
            $(".o-header").outerHeight()
          : (
              document.documentElement +
                $(window).height() -
                $(".o-header").outerHeight() ||
              document.body.parentNode +
                $(window).height() -
                $(".o-header").outerHeight() ||
              document.body
            ).scrollTop +
            $(window).height() -
            $(".o-header").outerHeight();
      if (scrollTop > startSticky && $(this).scrollTop() != t) {
        $(".o-unit-hero .m-sticky").addClass("fixed");
        $(".recaptcha-terms").css(
          "margin-bottom",
          $(".o-unit-hero .m-sticky").outerHeight()
        );
        if (document.body.clientWidth <= 767) {
          if ($("html").hasClass("ios")) {
            $(".scroll-to-top").css("bottom", "85px");
          } else {
            $(".scroll-to-top").css("bottom", "75px");
          }
        } else {
          $(".scroll-to-top").css("bottom", "80px");
        }
      } else {
        $(".o-unit-hero .m-sticky").removeClass("fixed");
        $(".recaptcha-terms").removeAttr("style");
        $(".scroll-to-top").css("bottom", "5%");
      }
    }
  };
  document.addEventListener("touchmove", stickyButtons, false);
  document.addEventListener("scroll", stickyButtons, false);
  document.addEventListener("resize", stickyButtons, false);
  document.addEventListener("gesturechange", stickyButtons, false);
}
// A.28. END -----------------------------------------------------------------------------------------------------------

// A.31. SHOW MORE/LESS ON UNIT PAGE HEROS -------------------------------------------------------------------------------------------------------

// function AddReadMore() {
//   var carLmt = 165;
//   var readMoreTxt = "Show me more";
//   var readLessTxt = "Show me less";

//   $(".addReadMore").each(function () {
//     if ($(this).find(".firstSec").length) return;

//     var allstr = $(this).text();
//     if (allstr.length > carLmt) {
//       var firstSet = $.trim(allstr)
//         .substring(0, carLmt)
//         .split(" ")
//         .slice(0, -1)
//         .join(" ");
//       var firstSet2 = allstr.substring(0, carLmt);
//       var secdHalf = allstr.substring(carLmt, allstr.length);

//       if (document.body.clientWidth <= 976) {
//         var strtoadd =
//           "<span class='hideMe'>" +
//           firstSet +
//           "</span>" +
//           "<span class='SecSec'>" +
//           firstSet2 +
//           secdHalf +
//           "</span><span class='readMore'  title='Click to Show More'>" +
//           readMoreTxt +
//           "</span><span class='readLess' title='Click to Show Less'>" +
//           readLessTxt +
//           "</span>";
//       } else {
//         var strtoadd =
//           firstSet +
//           "<span class='SecSec'>" +
//           firstSet2 +
//           secdHalf +
//           "<span class='readLess' title='Click to Show Less'>" +
//           readLessTxt +
//           "</span></span><span class='readMore'  title='Click to Show More'>" +
//           readMoreTxt +
//           "</span>";
//       }
//       $(this).html(strtoadd);
//     }
//   });
//   //Read More and Read Less Click Event binding
//   $(document).on("click", ".readMore,.readLess", function () {
//     $(this)
//       .closest(".addReadMore")
//       .toggleClass("showlesscontent showmorecontent");
//     if (document.body.clientWidth <= 976) {
//       $(this).closest(".addReadMore").toggleClass("hideMe");
//     }
//   });

//   if ($(".o-unit-hero").find(".o-unit-features").length > 0) {
//     $(".o-unit-hero").addClass("_features");
//   }
// }
// AddReadMore();

// A.31. END -----------------------------------------------------------------------------------------------------------

// A.33. Open concessions accordion if coming from concessions terms link
if (window.location.href.indexOf("#collapse0") > -1) {
  $("#collapse0").collapse();
}
// A.33. END -----------------------------------------------------------------------------------------------------------

// 2021 - Push footer to bottom of screen START

$(".o-2021-logo-black-strip")
  .parent()
  .parent()
  .parent()
  .css("margin-top", "auto");

// 2021 - Push footer to bottom of screen END

// 2021 - Basic cards character limit START

// var basicCardDescriptionLength = 200;
// jQuery(".o-2021-basic-image-cards .m-body .a-copy").each(function () {
//   var title = jQuery(this).text();
//   if (title.length > basicCardDescriptionLength) {
//     var shortText =
//       jQuery
//         .trim(title)
//         .substring(0, basicCardDescriptionLength)
//         .split(" ")
//         .slice(0, -1)
//         .join(" ") + "...";
//     jQuery(this).text(shortText);
//   }
// });

// END -----------------------------------------------------------------------------------------------------------

// MODALS -------------------------------------------------------------------------------------------------------------

// $(".a-info-icon").on("click", function (e) {
//   e.preventDefault();
//   e.stopPropagation();
//   console.log("this happened");
//   $("body").toggleClass("modal-open");
//   $(".o-benefits-modal").toggleClass("_is-open");
// });

// $(".a-modal-close-modal").on("click", function (e) {
//   e.preventDefault();
//   e.stopPropagation();
//   $("body").removeClass("modal-open");
//   $(".modal-backdrop").remove();
//   $(".o-benefits-modal").removeClass("show");
//   $(".o-benefits-modal").attr("aria-hidden", "true");
//   $(".o-benefits-modal").css("display", "none");
// });

// END: MODALS --------------------------------------------------------------------------------------------------------

// Cookie PRO scroll to bottom Safari bug fix START

// Cookie PRO scroll to bottom Safari bug fix END

// START: WEBFORM DATEPICKER ------------------------------------------
var datepickerOptions = {
  changeMonth: false,
  changeYear: false,
  monthNamesShort: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ],
  dayNamesMin: ["S", "M", "T", "W", "T", "F", "S"],
  firstDay: 1,
  dateFormat: "dd/mm/yy",
  minDate: new Date(),
  beforeShow: function (input, inst) {
    setTimeout(function () {
      if ($(window).width() < 767) {
        $(inst.input)
          .closest(".js-form-type-date")
          .css("margin-bottom", inst.dpDiv.outerHeight() + 40 + "px");
      }
      inst.dpDiv.css({
        top: $(input).offset().top + 69,
      });
    }, 1);
  },
  onChangeMonthYear: function (year, month, inst) {
    setTimeout(function () {
      if ($(window).width() < 767) {
        $(inst.input)
          .closest(".js-form-type-date")
          .css({ "margin-bottom": inst.dpDiv.outerHeight() + 40 + "px" });
      }
    }, 1);
  },
  onClose: function () {
    $(this).closest(".js-form-type-date").css("margin-bottom", "");
  },
};

$("form.enquire-about-unit.o-webform .js-form-type-date input.hasDatepicker").each(function () {
  var minDateAttr = $(this).attr("min");
  datepickerOptions.minDate = minDateAttr.length ? minDateAttr : new Date();
  $(this).datepicker("option", datepickerOptions);
});

$(document).ajaxSuccess(function () {
  if (
    $(
      "form.enquire-about-unit.o-webform .js-form-type-date input.hasDatepicker"
    ).length > 0
  ) {
    $(
      "form.enquire-about-unit.o-webform .js-form-type-date input.hasDatepicker"
    ).datepicker("option", datepickerOptions);
  }
});

// END: WEBFORM DATEPICKER ------------------------------------------

// Re-run blazy
function reRunBlazy() {
  if (typeof Blazy !== "undefined") {
    bLazy.revalidate();
  }
}

if (document.readyState === 'complete') {
  reRunBlazy();
} else {
  document.addEventListener('readystatechange', function() {
    if (document.readyState === 'complete') {
      reRunBlazy();
    }
  });
}
